import { useMemo } from 'react'
import { type Address } from 'use-towns-client'

/**
 * Mock hook for bot stake
 * TODO: Replace with actual blockchain data when staking is implemented
 */
export const useBotStake = (appAddress: Address | undefined) => {
    const mockData = useMemo(() => {
        return {
            totalStake: 0n,
            stakers: 0n,
        }
    }, [])

    return mockData
}
